import PropTypes from 'prop-types';
import React from 'react';
import './Filter.scss';

function Filter({
  filter,
  isActive,
  hasUnreads,
  length,
  onFilterSelected,
  onFilterClear,
  isError,
  className,
}) {
  const classes = [
    isActive ? 'active ' : '',
    hasUnreads ? 'unread-indicator' : '',
    isError ? 'error' : '',
  ];
  const displayLength = length ? `(${length})` : '';
  return (
    <button
      className={`Filter ${className || ''} no-caret`}
      role="menuitemradio"
      aria-checked={isActive}
      onClick={() => onFilterSelected(filter)}
    >
      <span className={classes.join(' ')}>
        {filter} {displayLength}{' '}
        {onFilterClear ? (
          <i
            className="Filter-clear-button far fa-times"
            onClick={(event) => {
              event.stopPropagation();
              onFilterClear(filter);
            }}
          />
        ) : null}
      </span>
    </button>
  );
}

Filter.defaultProps = {
  filter: '',
  isActive: false,
  hasUnreads: false,
  length: 0,
  onFilterSelected: () => {},
};

Filter.propTypes = {
  filter: PropTypes.string,
  isActive: PropTypes.bool,
  hasUnreads: PropTypes.bool,
  length: PropTypes.number,
  onFilterSelected: PropTypes.func,
  onFilterClear: PropTypes.func,
  isError: PropTypes.bool,
};

export default Filter;
